import isBlank from "@sedan-utils/is-blank";
export class CommonHeaderService {
    constructor(authStore, projectStore) {
        this.authStore = authStore;
        this.projectStore = projectStore;
    }
    get() {
        const brainToken = this.authStore.state.brainToken;
        const guestToken = this.authStore.state.guestToken;
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let headers = {
            "X-Brain-User-Tz": tz,
            "Content-Type": "application/json",
        };
        if (!isBlank(brainToken)) {
            headers["Authorization"] = `token ${brainToken}`;
        }
        else if (!isBlank(guestToken)) {
            headers["Brain-Guest-User-Key"] = guestToken;
        }
        const attrIndexer = this.projectStore.attrIndexer;
        if (!isBlank(attrIndexer)) {
            headers["X-Brain-Imagica-Id"] = attrIndexer;
        }
        return headers;
    }
}
